'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('../../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var boldStyle = { fontWeight: 'bold' };

var cardContentStype = {
  backgroundColor: 'rgba(0,0,0,.05)',
  fontWeight: 'bold'
};

var MobileReportTotals = function MobileReportTotals(_ref) {
  var totalImpressions = _ref.totalImpressions,
      totalReach = _ref.totalReach,
      totalEngagements = _ref.totalEngagements;
  return _react2.default.createElement(
    _semanticUiReact.Card.Content,
    { textAlign: 'center', style: cardContentStype },
    _react2.default.createElement(
      'h4',
      null,
      'TOTALS'
    ),
    _react2.default.createElement(
      _semanticUiReact.Statistic.Group,
      { size: 'tiny', widths: 'three' },
      _react2.default.createElement(
        _semanticUiReact.Statistic,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic.Value,
          { style: boldStyle },
          (0, _formatting.paidReportFormat)(totalImpressions)
        ),
        _react2.default.createElement(
          _semanticUiReact.Statistic.Label,
          null,
          'imps'
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Statistic,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic.Value,
          { style: boldStyle },
          (0, _formatting.paidReportFormat)(totalReach)
        ),
        _react2.default.createElement(
          _semanticUiReact.Statistic.Label,
          null,
          'reach'
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Statistic,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic.Value,
          { style: boldStyle },
          (0, _formatting.paidReportFormat)(totalEngagements)
        ),
        _react2.default.createElement(
          _semanticUiReact.Statistic.Label,
          null,
          'engs'
        )
      )
    )
  );
};

MobileReportTotals.propTypes = {
  totalImpressions: _propTypes2.default.number.isRequired,
  totalReach: _propTypes2.default.number.isRequired,
  totalEngagements: _propTypes2.default.number.isRequired
};

exports.default = MobileReportTotals;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/paid-report-row/mobile-components/totals.js
// module id = 2155
// module chunks = 1